<template>
  <div class="tjsq-box">
    <div class="tjsq-content">
      <div class="tjsq-icon">
        <img src="../../../assets/image/tijiaoshengqing_134@2x.png" alt="" />
      </div>
      <div class="tjsq-title">{{$t('all.shenqingyitijiao')}}</div>
      <div class="tjsq-desc">{{$t('all.shenqingtijiaodesc')}}</div>
      <div class="tjsq-info">
        <div class="tjsq-info-item">
          <span class="tjsq-info-item-label">{{$t('all.zhiboriqi')}}</span>
          <div class="tjsq-info-item-right">
            <span class="tjsq-info-item-value">{{liveDate}}</span>
            <img class="tjsq-info-item-arrow" src="../../../assets/image/jinru_14@2x.png" alt="" />
          </div>
        </div>
        <div class="tjsq-info-item">
          <span class="tjsq-info-item-label">{{$t('all.shijianshiduan')}}</span>
          <div class="tjsq-info-item-right">
            <span class="tjsq-info-item-value">{{timeSlot}}</span>
            <img class="tjsq-info-item-arrow" src="../../../assets/image/jinru_14@2x.png" alt="" />
          </div>
        </div>
      </div>
	  <div class="tjsq-status">
	    <span class="tjsq-status-label">{{$t('all.zhuangtai')}}</span>
	    <span class="tjsq-status-value">{{$t('all.daishenhe')}}</span>
	  </div>
      
      <div class="tjsq-btn" @click="handleViewRecord">{{$t('all.chakanshenheJilu')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      liveDate: '',
      timeSlot: ''
    };
  },
  mounted() {
    this.liveDate = this.$route.query.liveDate || '';
    this.timeSlot = this.$route.query.timeSlot || '';
  },
  methods: {
    handleViewRecord() {
      this.$router.push('/shenqingjilu');
    }
  }
};
</script>

<style scoped lang="scss">
@import "./tijiaoshenqing.css";
</style>



// WEBPACK FOOTER //
// tijiaoshenqing.vue?a5a2834e